import { EventEmitter, Injectable, Directive } from '@angular/core'

export interface IFilterOption {
  fieldName: string
  displayName: string
  operation: string
  type: string
  default?: boolean
}

export interface IQuickFilter {
  fieldName: string
  filter: string
  odataFilter: string
}

@Directive()
@Injectable()
export class GridQuickFilterServiceDirective {
  search: EventEmitter<IQuickFilter> = new EventEmitter<IQuickFilter>()
  resetFilters: EventEmitter<void> = new EventEmitter<void>()
}
